import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import RegistrationForm from "@/pages/RegistrationForm";
import AdminCustomers from "@/pages/AdminCustomers";
import CustomerGroups from "@/pages/CustomerGroups";
import WholesaleProducts from "@/pages/WholesaleProducts";
import PricingRules from "@/pages/PricingRules";
import OrderLimits from "@/pages/OrderLimits";
import ProductLimits from "@/pages/ProductLimits";
import ShippingRules from "@/pages/ShippingRules";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
       <Routes>
  <Route path="/register" element={<RegistrationForm />} />

  <Route element={<Layout />}>
    <Route index element={<Dashboard />} />

    <Route path="customers" element={<AdminCustomers />} />
    <Route path="groups" element={<CustomerGroups />} />
    <Route path="wholesale-products" element={<WholesaleProducts />} />
    <Route path="pricing-rules" element={<PricingRules />} />
    <Route path="order-limits" element={<OrderLimits />} />
    <Route path="product-limits" element={<ProductLimits />} />
    <Route path="shipping-rules" element={<ShippingRules />} />
    <Route path="settings" element={<Settings />} />
  </Route>
</Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
